import { render, staticRenderFns } from "./modalTalla.vue?vue&type=template&id=1366b0b1&scoped=true&"
import script from "./modalTalla.vue?vue&type=script&lang=js&"
export * from "./modalTalla.vue?vue&type=script&lang=js&"
import style0 from "./modalTalla.vue?vue&type=style&index=0&id=1366b0b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1366b0b1",
  null
  
)

export default component.exports